export default "__VITE_ASSET__KQHFrvav__"